const ITEMS = ["Joint jelly, explained", "Mobilee®", "French maritime pine bark", "Boswellia serrata", "Ginger root", "BioPerine®", "One daily ritual"];

const Row = ({ hidden, items, dot }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-6 font-serif text-3xl italic text-[#091D18] sm:text-5xl">{t}</span>
        <span className="h-3 w-3 rounded-full" style={{ background: dot }} />
      </span>
    ))}
  </div>
);

export const Marquee = ({ items = ITEMS, dot = "#D96B43" }) => (
  <section className="overflow-hidden border-y border-[#091D18]/10 bg-[#F2EDE4] py-7" data-testid="editorial-marquee">
    <div className="marquee flex w-max">
      <Row items={items} dot={dot} />
      <Row items={items} dot={dot} hidden />
    </div>
  </section>
);
